module.exports = __webpack_public_path__ + "static/media/link.d6032d86.svg";